import { HQ_SERVICE, mockPath } from "constants/app";
import { getRequest, checkStatus, parseStatusAndBody } from "helpers/requests";
import { sortEntitiesByBrand } from "helpers/transforms/account";
import { IBrandGroup, ILocation } from "types/account";

const MOCK_LOCATIONS = `/locations`;

function getLocations(permalink: string): Promise<IBrandGroup[]> {
  const locationsPath = mockPath(
    `${HQ_SERVICE}/locations.json`,
    MOCK_LOCATIONS
  );
  return fetch(
    `${locationsPath}?store_key=${encodeURIComponent(permalink)}`,
    getRequest()
  )
    .then(response => parseStatusAndBody<ILocation[]>(response))
    .then((parsedResponse: [number, ILocation[]]) =>
      checkStatus<ILocation[]>(parsedResponse)
    )
    .then(sortEntitiesByBrand);
}

export { getLocations };
